const ruleItemTypes = {
    TOPIC: 'topics',
    LOGO: 'logos',
    KEYWORD: 'keywords',
};

export default ruleItemTypes;
